const DamagesIndex = () => import('./index.vue');
const CreateDamage = () => import('./_pages/create.vue');
const ViewDamage = () => import('./_pages/view.vue');


export default [
    {
        path: '/damages',
        component: DamagesIndex
    },
    {
        path: '/create-damage',
        component: CreateDamage
    },
    {
        path: '/view-damage/:id',
        component: ViewDamage
    },
];